import ApplianceService from "../ApplianceService"
import ApplianceRepairEntity from "../Entity/ApplianceRepairEntity"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    DELETING_RECORD = "DELETING_RECORD",
    DELETING_RECORD_SUCCESS = "DELETING_RECORD_SUCCESS",
    DELETING_RECORD_ERROR = "DELETING_RECORD_ERROR",
    CLEAR_RECORD = "CLEAR_RECORD",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    isDeleting: false,
    records: [],
    totalRecords: 0,
    error: null,
}

export const state = {...initialState}

export const actions = {

    /**
     * @param commit
     * @param id : Int
     * @returns {Promise<[]>}
     */
    async findRepairs({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await ApplianceService.getApplianceRepairs(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param appliance : Int
     * @param repair : String
     * @returns {Promise<*>}
     */
    async deleteRepair({commit}, {appliance, repair}) {
        try {
            commit(DELETING_RECORD)
            let response = await ApplianceService.deleteApplianceRepair(appliance, repair)
            commit(DELETING_RECORD_SUCCESS, response.data)
            return response.data
        } catch (error) {
            commit(DELETING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    async clear({commit}) {
        commit(CLEAR_RECORD)
    },

    async clearAll({commit}) {
        commit(CLEAR_RECORDS)
    },

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.error = null
        state.records = []
        state.totalRecords = 0
    },
    [FETCHING_RECORDS_SUCCESS](state, records) {
        state.isLoading = false
        state.records = records.map(record => ApplianceRepairEntity.from(record))
        state.totalRecords = records.length
    },
    [FETCHING_RECORDS_ERROR](state, error) {
        state.isLoading = false
        state.error = error
        state.records = []
        state.totalRecords = 0
    },

    [DELETING_RECORD](state) {
        state.isDeleting = true
        state.error = null
    },
    [DELETING_RECORD_SUCCESS](state) {
        state.isDeleting = false
        state.error = null
    },
    [DELETING_RECORD_ERROR](state, error) {
        state.isDeleting = false
        state.error = error
    },

    [CLEAR_RECORD](state) {
        state.isLoading = false
        state.error = null
        state.record = null
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.error = null
        state.records = []
        state.totalRecords = 0
    },

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },

    isDeleting(state) {
        return state.isDeleting
    },

    hasError(state) {
        return state.error !== null
    },

    error(state) {
        return state.error
    },

    hasRepairs(state) {
        return state.records.length > 0
    },

    getRepairs(state) {
        return state.records
    },

    getTotalRepairs(state) {
        return state.totalRecords
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
